<template>
    <footer class="footer-component">
        <div class="actionbar actionbar-bottom visible-xs" v-if="footerShow">
            <div
                class="actionbar_item"
                v-for="item in footerButtons"
                :class="{ active: item.active }"
                @click="onClick(item)"
            >
                <span
                    :class="{
                        big: item.id === 'new-trip',
                        'width-badges': item.id === 'notifications'
                    }"
                    class=""
                >
                    <svgItem size="26" :icon="item.icon"></svgItem>
                    <span
                        class="badge"
                        v-if="
                            notificationsCount > 0 &&
                            item.id === 'notifications'
                        "
                    >
                        {{ notificationsCount }}
                    </span>
                </span>
            </div>
        </div>
        <div class="container hidden-xs" v-if="config.enable_footer && !isProfileMePage && !isNouveauProfil">
            <div class="row">
                <div class="col-xs-6 col-md-6">
                    <h3>{{ $t('footerAcercaDe') }}</h3>
                    <ul>
                        <li>
                            <router-link tag="a" :to="{ name: 'acerca_de' }">
                                Carpoolear
                            </router-link>
                        </li>
                        <li>
                            <a
                                href="https://app.myecocar.fr/acerca-de-equipo"
                                target="_blank"
                            >
                                {{ $t('footerEquipo') }}
                            </a>
                        </li>
                        <li>
                            <a
                                href="http://www.stsrosario.org.ar/"
                                target="_blank"
                                >STS Rosario</a
                            >
                        </li>
                    </ul>
                </div>
                <div class="col-xs-6 col-md-6">
                    <h3>{{ $t('footerAyuda') }}</h3>
                    <ul>
                        <!--<li><a href="https://carpoolear.com.ar/tutoriales.php" target="_blank">Tutoriales de uso</a></li>-->
                        <li>
                            <a
                                href="https://app.myecocar.fr/plataforma-preguntas-frecuentes"
                                target="_blank"
                            >
                                {{ $t('footerPreguntasFrecuentes') }}
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://app.myecocar.fr/plataforma-recomendaciones"
                                target="_blank"
                            >
                                {{ $t('footerRecomendaciones') }}
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="col-xs-6 col-md-6">
                    <h3>{{ $t('footerEncontranosEn') }}</h3>
                    <ul>
                        <li>
                            <a href="https://www.facebook.com/Carpoolear">
                                <i
                                    class="fa fa-facebook"
                                    aria-hidden="true"
                                ></i>
                                <span>{{ $t('footerFacebook') }}</span>
                            </a>
                        </li>
                        <li>
                            <a href="https://twitter.com/carpoolear">
                                <i class="fa fa-twitter" aria-hidden="true"></i>
                                <span>{{ $t('footerTwitter') }}</span>
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://www.instagram.com/carpoolear/?hl=en"
                            >
                                <i
                                    class="fa fa-instagram"
                                    aria-hidden="true"
                                ></i>
                                <span>{{ $t('footerInstagram') }}</span>
                            </a>
                        </li>
                        <li>
                            <a href="https://github.com/STS-Rosario">
                                <i class="fa fa-github" aria-hidden="true"></i>
                                <span>{{ $t('footerGithub') }}</span>
                            </a>
                        </li>
                        <li>
                            <a :href="'mailto:' + config.admin_email">
                                <i
                                    class="fa fa-envelope-o"
                                    aria-hidden="true"
                                ></i>
                                <span>{{ $t('footerCorreo') }}</span>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="col-xs-6 col-md-6">
                    <h3>{{ $t('footerInformacionLegal') }}</h3>
                    <p>{{ $t('footerEnRutaDesde') }}</p>
                    <ul>
                        <li>
                            <router-link :to="{ name: 'terms' }">
                                {{ $t('footerTerminosCondiciones') }}
                            </router-link>
                        </li>
                        <li>
                            <router-link tag="a" :to="{ name: 'cgu' }">
                                CGU
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="modern-footer" v-if="config.enable_footer && isProfileMePage">
            <div class="modern-footer-container">
                <div class="modern-footer-left">
                    <div class="modern-footer-logo-section">
                        <img
                            src="https://i.imgur.com/z198fac.png"
                            alt="MyEcoCar Logo"
                            class="modern-footer-logo"
                        />
                        <span class="modern-footer-brand-name">MyEcoCar</span>
                    </div>
                    <div class="modern-footer-social-links">
                        <a href="#" class="modern-social-link" title="Facebook">
                            <i class="fa fa-facebook-f"></i>
                        </a>
                        <a href="#" class="modern-social-link" title="Twitter">
                            <i class="fa fa-twitter"></i>
                        </a>
                        <a href="#" class="modern-social-link" title="Instagram">
                            <i class="fa fa-instagram"></i>
                        </a>
                        <a href="#" class="modern-social-link" title="LinkedIn">
                            <i class="fa fa-linkedin"></i>
                        </a>
                    </div>
                </div>

                <div class="modern-footer-center">
                    <div class="modern-footer-column">
                        <h4 class="modern-footer-column-title">Infos</h4>
                        <ul class="modern-footer-links">
                            <li><router-link :to="{ name: 'cgu' }">CGU</router-link></li>
                            <li><router-link :to="{ name: 'faq' }">FAQ</router-link></li>
                            <li><router-link :to="{ name: 'contact' }">Contact</router-link></li>
                        </ul>
                    </div>

                    <div class="modern-footer-column">
                        <h4 class="modern-footer-column-title">Découvrir</h4>
                        <ul class="modern-footer-links">
                            <li><router-link :to="{ name: 'about' }">Qui sommes-nous ?</router-link></li>
                            <li><router-link :to="{ name: 'conduct-charter' }">Charte de bonne conduite</router-link></li>
                            <li><router-link :to="{ name: 'map' }">Carte Interactive</router-link></li>
                        </ul>
                    </div>

                    <div class="modern-footer-column">
                        <h4 class="modern-footer-column-title">Plus</h4>
                        <ul class="modern-footer-links">
                            <li><router-link :to="{ name: 'concept' }">Notre Concept</router-link></li>
                            <li><router-link :to="{ name: 'cookies' }">Utilisation des cookies</router-link></li>
                            <li><router-link :to="{ name: 'sitemap' }">Plan du site</router-link></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="modern-footer-bottom">
                <p class="modern-footer-copyright">
                    &copy; {{ new Date().getFullYear() }} MyEcoCar. Tous les droits réservés.
                </p>
            </div>
        </div>
    </footer>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import svgItem from '../SvgItem';

export default {
    name: 'footerApp',
    data() {
        return {};
    },
    computed: {
        ...mapGetters({
            footerButtons: 'actionbars/footerButtons',
            footerShow: 'actionbars/footerShow',
            notificationsCount: 'notifications/count',
            config: 'auth/appConfig'
        }),
        isNouveauProfil() {
            return this.$route && this.$route.name === 'nouveau_profil';
        },
        isProfileMePage() {
            // Afficher le modern-footer SEULEMENT pour /profile/me (ancien profil)
            // EXCLURE nouveau_profil car il a son propre footer custom
            return this.$route && 
                   this.$route.name === 'profile' && 
                   this.$route.params && 
                   this.$route.params.id === 'me';
        }
    },
    methods: {
        ...mapActions({
            onClick: 'actionbars/footerButtonClick'
        })
    },
    components: {
        svgItem
    }
};
</script>

<style scoped>
h3 {
    font-size: 18px;
}
.width-badges {
    position: relative;
}
.badge {
    position: absolute;
    background-color: red;
    right: 5px;
    bottom: 3px;
    font-size: 10px;
    height: auto;
    width: auto;
    padding: 3px 4px !important;
}

.modern-footer {
    background: linear-gradient(135deg, #1f3f2e 0%, #2d5016 100%);
    color: #ffffff;
    width: 100vw;
    margin-left: calc(-50vw + 50%);
    margin-right: calc(-50vw + 50%);
    margin-top: 4rem;
    margin-bottom: 0;
    padding: 3rem 1rem 0;
}

.modern-footer-container {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 0.8fr 1.2fr;
    gap: 3rem;
    align-items: start;
}

.modern-footer-left {
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.modern-footer-logo-section {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.modern-footer-logo {
    width: 50px;
    height: 50px;
    object-fit: contain;
}

.modern-footer-brand-name {
    font-family: 'Poppins', sans-serif;
    font-size: 1.5rem;
    font-weight: 700;
    color: #aef7b9;
}

.modern-footer-social-links {
    display: flex;
    gap: 1rem;
    align-items: center;
}

.modern-social-link {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #aef7b9;
    text-decoration: none;
    transition: all 0.3s ease;
}

.modern-social-link:hover {
    background: rgba(174, 247, 185, 0.2);
    color: #ffffff;
    transform: translateY(-3px);
}

.modern-social-link i {
    font-size: 1.25rem;
}

.modern-footer-center {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2.5rem;
}

.modern-footer-column {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.modern-footer-column-title {
    font-family: 'Poppins', sans-serif;
    font-size: 1.1rem;
    font-weight: 600;
    color: #aef7b9;
    margin: 0;
}

.modern-footer-links {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.modern-footer-links li {
    margin: 0;
}

.modern-footer-links a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 0.95rem;
    transition: color 0.3s ease;
}

.modern-footer-links a:hover {
    color: #aef7b9;
    text-decoration: underline;
}

.modern-footer-bottom {
    text-align: center;
    margin-top: 2rem;
    padding-top: 2rem;
    padding-bottom: 1.5rem;
    border-top: 1px solid rgba(174, 247, 185, 0.2);
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
}

.modern-footer-copyright {
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.7);
    margin: 0;
}

@media (max-width: 1024px) {
    .modern-footer-container {
        grid-template-columns: 1fr;
        gap: 2rem;
    }

    .modern-footer-center {
        grid-template-columns: repeat(3, 1fr);
        gap: 2rem;
    }
}

@media (max-width: 768px) {
    .modern-footer {
        padding: 2rem 1rem 1rem;
        margin-top: 3rem;
    }

    .modern-footer-left {
        gap: 1.5rem;
    }

    .modern-footer-center {
        grid-template-columns: 1fr;
        gap: 1.5rem;
    }

    .modern-footer-column {
        gap: 0.75rem;
    }

    .modern-footer-column-title {
        font-size: 1rem;
    }

    .modern-footer-links a {
        font-size: 0.9rem;
    }

    .modern-footer-logo {
        width: 40px;
        height: 40px;
    }

    .modern-footer-brand-name {
        font-size: 1.25rem;
    }
}

@media (max-width: 480px) {
    .modern-footer {
        padding: 1.5rem 1rem;
        margin-top: 2rem;
    }

    .modern-footer-logo {
        width: 35px;
        height: 35px;
    }

    .modern-footer-brand-name {
        font-size: 1.1rem;
    }

    .modern-social-link {
        width: 38px;
        height: 38px;
    }

    .modern-social-link i {
        font-size: 1.1rem;
    }
}
</style>
